module.exports = __webpack_public_path__ + "img/stretch.ab56ccee.png";